import { Link } from "react-router-dom";
import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";
import Layout2 from "@/components/Layout/Layout2";
import LeftBar2 from "@/components/Layout/LeftBar2";
import { backofficeLinks } from "@/components/lib/SidebarLinks";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Separator } from "@radix-ui/react-separator";
import DrinkListTabs from "@/components/menu-management/drink-manage/drink/drink-list-tabs";
import DraftList from "@/components/menu-management/drink-manage/drink/draft-list-tabls";
import { useDispatch, useSelector } from "react-redux";
import useAuth from "@/hooks/useAuth";
import TableSkeleton from "@/components/skeleton/table-skeletion";
import {
  fetchAllDrinks,
  clearDrinkMessages,
} from "@/redux/slice/menu-manage-slice/drink-slice";
import { clearItemVariants } from "@/redux/slice/essential-menu-slice/variants-slice";
import hasPermission from "@/hooks/hasPermission";

function Drinks() {
  const { user } = useAuth();
  const dispatch = useDispatch();
  const { getLoading } = useSelector((state) => state.menuManage.drink);
  useEffect(() => {
    dispatch(fetchAllDrinks(user?.restaurant_id));
    dispatch(clearDrinkMessages());
    dispatch(clearItemVariants());
  }, [user?.restaurant_id]);

  if (getLoading) return <TableSkeleton links={backofficeLinks} />;

  return (
    <Layout2
      pageName={{ title: "Drinks List" }}
      paths={[
        { name: "home", path: "/home" },
        { name: "Back Office", path: "/backoffice/overview" },
        { name: "Menu Management", path: "/backoffice/menu/drinks" },
        { name: "Drinks", path: "/backoffice/menu/drinks" },
      ]}
      LeftBar={<LeftBar2 sidebarLinks={backofficeLinks} />}
    >
      <div className="container flex flex-col gap-4 mt-5">
        <div className="flex justify-end items-start md:items-center md:flex-row flex-col  w-full">
          {hasPermission("back_office.menu_management.create_drinks") && (
            <Link to={"/backoffice/menu/drinks/create"}>
              <Button>
                <Plus /> Create Drinks
              </Button>
            </Link>
          )}
        </div>
        <Tabs valueKey="menu-drinks" className="bg-transparent relative" defaultValue="drink">
          <TabsList className="grid grid-cols-6 w-full">
            <Separator className="absolute top-8 " />
            <TabsTrigger className="bg-transparent" value="drink">
              Drinks List
            </TabsTrigger>
            <TabsTrigger value="draft">Draft List</TabsTrigger>
          </TabsList>
          <Separator className=" absolute top-8 w-full h-[1px] bg-neutral-700" />
          <DrinkListTabs />
          <DraftList />
        </Tabs>
      </div>
    </Layout2>
  );
}

export default Drinks;
